import { render } from "./removeBarrierIcon.svg?vue&type=template&id=6fb88209"
const script = {}
script.render = render

export default script